import '../App.css';
import Section_0 from './Section_0.js';
import Section_1 from './Section_1';
export default function Section(){
    const s1={
    }
    return (
        <div style={s1}>
        <Section_0/>
        <Section_1/>
        </div>
    )
}